import { useContext, useState, useEffect } from 'react';
import { RemotionPlayerContext } from '../context/RemotionPlayerContext';
import { FPS_24 } from '@/App/remotion/constants';
import { roundToNDecimalPlaces } from '@/libs/utils';

export const useRemotionPlayerCurrentTime = () => {
  const { playerRef } = useContext(RemotionPlayerContext);

  const [currentTime, setCurrentTime] = useState(0);

  useEffect(() => {
    if (playerRef) {
      const handleTimeUpdate = ({ detail: { frame } }: { detail: { frame: number } }) => {
        setCurrentTime(roundToNDecimalPlaces(frame / FPS_24, 3));
      };
      playerRef.addEventListener('timeupdate', handleTimeUpdate);
      return () => {
        playerRef.removeEventListener('timeupdate', handleTimeUpdate);
      };
    }
  }, [playerRef]);

  return { currentTime };
};
